import {
  preCreateTokenStripeRestaurant,
  watchCreateTokenStripeRestaurant,
} from "./restaurant.saga";

import { all } from "redux-saga/effects";

export default function* IndexSaga() {
  yield all([
    preCreateTokenStripeRestaurant(),
    watchCreateTokenStripeRestaurant(),
  ]);
}
